import * as React from 'react';

function SvgCaretdownfilledIcon(props) {
  return (
    <svg
      width={10}
      height={7}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6.75a1.29 1.29 0 01-.995-.481L.845 2.445A1.564 1.564 0 01.652.787C.881.3 1.335 0 1.841 0H8.16c.504 0 .96.301 1.188.787.26.55.184 1.2-.193 1.657L5.995 6.27A1.29 1.29 0 015 6.75z"
        fill="#232340"
      />
    </svg>
  );
}

export default SvgCaretdownfilledIcon;
